<h3 class="ui primary header">
  {{ modal.context.title }}
  <!-- <i class="link times icon" (click)="modal.deny(undefined)"></i> -->
</h3>
<div *ngIf="success || error" appMargin marginY="10px">
  <esl-message-toast
    [close]="false"
    [(message)]="success"
    [messageType]="'success'"
  ></esl-message-toast>
  <esl-message-toast [(message)]="error"></esl-message-toast>
</div>
<div class="content">
  <div class="scroll-wrapper ui basic segment" [ngClass]="{ loading: pending }">
    <div *ngIf="!isActive && !recoveryActive">
      <div class="ui form">
        <div class="grouped fields">
          <label
            ><h3>
              Two factor authentication(2FA) is an extra layer of security used
              when logging into websites or apps.
            </h3></label
          >
          <div class="field" appMargin marginT="10">
            <div>
              <sui-radio-button name="example" value="app" [(ngModel)]="eRadio"
                ><strong>Setup Using an app</strong> <br />
                <p
                  style="
                    color: #6b7280;
                    font-family: Roboto;
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 20px;
                  "
                >
                  Use an application on your phone to get two-factor
                  authentication codes when prompted . We recommend using
                  cloud-based TOTP apps such as: Google Authenticator or
                  Microsoft Authenticator which can be downloaded on the Google
                  Play Store or the Apple App Store
                </p>
              </sui-radio-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      *ngIf="isActive && !recoveryActive"
      class="ui form"
      [formGroup]="twoFactorForm"
    >
      <p class="heading">
        Scan the image below with the two-factor Authenticator App on your
        phone.
      </p>
      <div class="ui vertical basic segment" appMargin marginY="0px">
        <iframe
          allowfullscreen
          [src]="barCode"
          style="border: none; height: 350px; width: 400px"
        ></iframe>
      </div>
      <p class="scan-text">
        After scanning the QR code image, the app will display a code that you
        can enter below.
      </p>
      <div class="field" [ngClass]="displayFieldCss('twoFactor_name')">
        <label class="code-text">Enter the code from the application</label>
        <input type="text" formControlName="twoFactor_name" />
        <app-field-error-display
          [displayError]="isFieldValid('twoFactor_name')"
          errorMsg="Please enter twoFactor name"
        >
        </app-field-error-display>
      </div>
    </div>
    <div *ngIf="recoveryActive && !isActive">
      <h4 style="font-family: Roboto; font-size: 14px; font-weight: 500">
        Save your recovery code
      </h4>
      <div
        style="
          margin: 20px 0px;
          display: grid;
          grid-template-columns: 1fr 1fr 1fr;
        "
      >
        <p *ngFor="let code of recoveryCodes"
          style="
            font-size: 14px;
            font-weight: 700;
            line-height: 20px;
            letter-spacing: 0em;
            text-align: left;
            color: #505050;
          "
        >
          {{ code }}
        </p>
      </div>
      <button
        class="ui primary button"
        [ngClass]="{ yellow: pending }"
        (click)="downloadToFile()"
        autofocus
      >
        Download
      </button>
      <div style="margin-top: 30px">
        <h4 style="font-family: Roboto; font-size: 14px; font-weight: 500">
          Enter the code from the application
        </h4>
        <p style="font-family: Roboto; font-size: 14px; font-weight: 400">
          If you lose access to your phone, you can authenticate to E-services
          using your recovery code. We recommend saving them with a secure
          password manager
        </p>
      </div>
    </div>
  </div>
</div>

<div class="actions">
  <button
    *ngIf="!recoveryActive"
    class="ui basic primary button"
    [disabled]="enabled"
    (click)="modal.deny(undefined)"
  >
    Cancel
  </button>
  <button
    *ngIf="!recoveryActive"
    class="ui primary button"
    [ngClass]="{ yellow: pending }"
    [disabled]="pending || enabled"
    (click)="submit()"
    autofocus
  >
    Continue
  </button>
  <button
    *ngIf="recoveryActive && !isActive"
    class="ui primary button"
    style="margin-left: 0 !important;"
    [ngClass]="{ yellow: pending }"
    (click)="modal.approve()"
    autofocus
  >
    I have saved my recovery code
  </button>
</div>
